<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/playlists"></ion-back-button>
    </ion-buttons>
    <ion-title>Spotify Profile</ion-title>
    <ion-buttons slot="end" *ngIf="isAuthenticated">
      <ion-button fill="clear" (click)="logout()" aria-label="Disconnect Spotify">
        <ion-icon slot="icon-only" name="log-out-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <!-- ─── Not authenticated ───────────────────────────────────────────────── -->
  <div *ngIf="!isAuthenticated" class="auth-prompt">
    <ion-icon name="musical-notes-outline" class="spotify-icon"></ion-icon>
    <h2>Connect to Spotify</h2>
    <p class="subtitle">
      Authorize this app to verify the OAuth PKCE flow and display your
      Spotify profile.
    </p>
    <ion-button expand="block" class="spotify-btn" (click)="login()">
      Connect with Spotify
    </ion-button>
  </div>

  <!-- ─── Loading ─────────────────────────────────────────────────────────── -->
  <div *ngIf="isAuthenticated && loading" class="center-state">
    <ion-spinner name="crescent"></ion-spinner>
    <p>Fetching profile from Spotify&hellip;</p>
  </div>

  <!-- ─── Error ───────────────────────────────────────────────────────────── -->
  <div *ngIf="isAuthenticated && !loading && error" class="center-state">
    <ion-icon name="alert-circle-outline" color="danger" class="state-icon"></ion-icon>
    <p class="error-text">{{ error }}</p>
    <ion-button fill="outline" (click)="fetchProfile()">Retry</ion-button>
  </div>

  <!-- ─── Profile ─────────────────────────────────────────────────────────── -->
  <div *ngIf="isAuthenticated && !loading && !error && profile">

    <!-- Avatar + display name -->
    <div class="profile-header">
      <img
        *ngIf="profile?.images?.[0]?.url"
        [src]="profile.images[0].url"
        [alt]="profile.display_name"
        class="avatar"
      />
      <ion-icon
        *ngIf="!profile?.images?.[0]?.url"
        name="person-circle-outline"
        class="avatar-placeholder"
      ></ion-icon>
      <div class="profile-names">
        <h2>{{ profile.display_name }}</h2>
        <p class="profile-email">{{ profile.email }}</p>
      </div>
    </div>

    <!-- Parsed fields -->
    <ion-list class="profile-list" lines="full">
      <ion-item>
        <ion-label>
          <p class="field-label">Spotify ID</p>
          <p>{{ profile.id }}</p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label>
          <p class="field-label">Country</p>
          <p>{{ profile.country }}</p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label>
          <p class="field-label">Product</p>
          <p>{{ profile.product }}</p>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-label>
          <p class="field-label">Followers</p>
          <p>{{ profile.followers?.total }}</p>
        </ion-label>
      </ion-item>
    </ion-list>

    <!-- Raw JSON for debugging / verification -->
    <details class="raw-json">
      <summary>Raw <code>/v1/me</code> response</summary>
      <pre>{{ profile | json }}</pre>
    </details>

    <ion-button expand="block" fill="outline" class="refresh-btn" (click)="fetchProfile()">
      <ion-icon slot="start" name="refresh-outline"></ion-icon>
      Refresh
    </ion-button>
  </div>

  <!-- ─── Access token (debug) ────────────────────────────────────────────── -->
  <details *ngIf="isAuthenticated" class="token-debug">
    <summary>Access token</summary>
    <p class="token-text">{{ accessToken }}</p>
    <ion-button size="small" fill="outline" (click)="copyToken()">
      <ion-icon slot="start" [name]="copied ? 'checkmark-outline' : 'copy-outline'"></ion-icon>
      {{ copied ? 'Copied!' : 'Copy' }}
    </ion-button>
  </details>

</ion-content>
